<!-- 二级导航 -->
<template>
  <ul class='sub-nav'>
    <li v-for='(nav,index) in navBars' :key='index' @click='goRouter(nav.path)'>
      <a href='javascript:;'>{{ nav.label }}&gt;</a>
    </li><li>
      <a href='javascript:;'>{{ componentName }}</a>
    </li>
  </ul>
</template>
<script>

export default {
  props: ['navs'],
  computed: {
    navBars() {
      return this.navs
    },
    componentName() {
      return this.$route.name
    }
  }
}
</script>
<style lang='less' scoped>
@import "../assets/css/mixin.less";
.sub-nav {
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: @blue-d;

  li {
    display: inline-block;
    a {
      color: @blue-d;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/SubNav.vue